document.addEventListener('DOMContentLoaded', () => {
  // Select only header menus (adjust selector if needed)
  const headerDetails = document.querySelectorAll('header details, .header details');

  // Desktop only (important for mobile)
  if (!window.matchMedia('(hover: hover)').matches) return;

  headerDetails.forEach(details => {
    const summary = details.querySelector('summary');

    // Open on hover
    details.addEventListener('mouseenter', () => {
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    });

    // Close on leave
    details.addEventListener('mouseleave', () => {
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    });

    // Prevent click toggle
    summary.addEventListener('click', (e) => {
      e.preventDefault();
    });
  });
  
});



document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.testimonial-slider .testimonials');
  if (!slider) return;

  const slides = slider.querySelectorAll('.slider__slide');
  let currentIndex = 0;

  setInterval(() => {
    currentIndex = (currentIndex + 1) % slides.length;

    slider.scrollTo({
      left: slides[currentIndex].offsetLeft,
      behavior: 'smooth'
    });
  }, 5000); // 5 sec
});
// Glitch site pass phase 4, 2 Oct 2026 (Task 14.5): only pages with the comparison table have this dropdown, so ?. skips the listener elsewhere instead of throwing. The stray log of each iframe is gone.
document.addEventListener('DOMContentLoaded', function () {
document.getElementById('comparison-table_otherproducts-dropdown')
    ?.addEventListener('change', function () {
      console.log('Selected value:', this.value);
      const ytVideo = document.querySelectorAll('.yt_player_iframe');
      ytVideo.forEach((iframe) => {
 iframe.contentWindow.postMessage(
    '{"event":"command","func":"stopVideo","args":""}',
    '*'
  );
});
    });
     });
// Glitch site pass phase 4, 3 Oct 2026 (Task 15.2): the YouTube API now loads only where it is needed (the video landing page's own async tag, or a facade tap), so the filter videos are bound only once YT.Player exists. onYouTubeIframeAPIReady below binds each iframe once, because the API's own ready call can fire as well.
document.addEventListener('DOMContentLoaded', function () {
  if (window.YT && typeof window.YT.Player === 'function') onYouTubeIframeAPIReady();
});

// detect youtube video iframe playing 
  let player;

function onYouTubeIframeAPIReady() {
  document.querySelectorAll('.yt-filter-content.tab-content iframe').forEach((iframe) => {
    if (iframe.dataset.ytBound) return; iframe.dataset.ytBound = '1';
    new YT.Player(iframe, {
      events: {
        onStateChange: function (event) {
          const wrapper = iframe.closest('.yt-filter-content');

          if (event.data === YT.PlayerState.PLAYING) {
            wrapper.classList.add('playing');
          }

          if (
            event.data === YT.PlayerState.PAUSED ||
            event.data === YT.PlayerState.ENDED
          ) {
            wrapper.classList.remove('playing');
          }
        }
      }
    });
  });
}
// alert("qwer");

// const elementWithDataId = document.querySelectorAll('.select_select'); 

//   const selectedValue = elementWithDataId.value; // selectedValue will be "apartment" initially if not specified otherwise
//   alert(selectedValue);


  // const selectElement = document.getElementById("accommodation-select");
  // const selectedValue = selectElement.value; // selectedValue will be "apartment" initially if not specified otherwise
  // console.log(selectedValue);



  // Adding custom Price filter in collection page 


document.querySelectorAll('.price-radio-group input[type="radio"]')
  .forEach(function(radio) {

    radio.addEventListener('change', function() {

      const min = this.dataset.min;
      const max = this.dataset.max;

      const form = document.querySelector('facet-filters-form form');
      if (!form) return;

      // Remove existing hidden price inputs
      form.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]')
        .forEach(el => el.remove());

      // Add GTE
      if (min !== "") {
        const inputMin = document.createElement('input');
        inputMin.type = 'hidden';
        inputMin.name = 'filter.v.price.gte';
        inputMin.value = min;
        form.appendChild(inputMin);
        const inputMax = document.createElement('input');
        inputMax.type = 'hidden';
        inputMax.name = 'filter.v.price.lte';
        inputMax.value = max;
        inputMin.value = min;
        form.appendChild(inputMax);
      }

      // Add LTE
      if (max !== "") {
        const inputMax = document.createElement('input');
        inputMax.type = 'hidden';
        inputMax.name = 'filter.v.price.lte';
        inputMax.value = max;
        inputMin.value = min;
        form.appendChild(inputMax);
      }

      // Submit Dawn filter form (AJAX)
      form.dispatchEvent(new Event('submit', { bubbles: true }));

    });

});


// redirect account page to the cart if customer logged in
// document.addEventListener("DOMContentLoaded", function() {
// var wNineelement = document.querySelector("#w_nine_click");
// const wNpopup=  document.querySelector(".w-nine-form");
// function openPopUp() {
//   wNpopup.style.visibility = "visible";
//   wNpopup.style.opacity = "1";
//   wNpopup.style.position = "absolute";
//   wNpopup.style.top = "50%";
//   wNpopup.style.left = "50%";
//   wNpopup.style.width = "44%";
//   wNpopup.style.transform = "translate(-50%, -50%)";
  
// }

// // click event
// wNineelement.addEventListener("click", function(e) {
// //  alert();
//   openPopUp();
// });

// });




//spareklayed price change when varaint changes.
document.addEventListener('DOMContentLoaded',()=>{
 setTimeout(() => {
  const shadowHost = document.querySelector('spark-pdp');
  // Glitch site pass phase 4, 2 Oct 2026 (Task 14.5): stop when the page has no SparkLayer widget, instead of throwing.
  if (!shadowHost || !shadowHost.shadowRoot) return;
  const shadowRoot = shadowHost.shadowRoot;  
  const selects = shadowRoot.querySelectorAll('select');
  // const rrpPrice = shadowRoot.querySelector('.sl-pricing-alignment p:nth-child(2)');
  // rrpPrice.style.display = "none";

    //change the prouct price of spark layer on variant change
    selects.forEach(select => {
      shadowRoot.addEventListener('change', function(e) {
        const varianPrice = shadowRoot.querySelector('tbody tr:first-child td:nth-child(3)');
        const productPrice = shadowRoot.querySelector('.sl-pricing-alignment p');
        const customMsrp = shadowRoot?.querySelector('.spark-custom-price');

        //hide the msrp when variant change
        if (customMsrp.includes('MSRP:')) {
          // el.innerHTML = html.replace(
          //   /(MSRP:[^<]*)/,
          //   '<span class="msrp">$1</span>'
          // );
          console.log('customMsrp');
        }


        console.log(varianPrice);

            if (productPrice && varianPrice) {

              // Get last (bottom) element
              const lastPrice = varianPrice.innerText;;

              // Replace price-summary text
              productPrice.innerText = lastPrice;
              if (productPrice) {
                const newP = document.createElement('p');
                newP.className = 'spark-custom-price';
                newP.className = 'spark-custom-price';
                newP.style.fontSize = '16px';
                newP.style.marginBottom = '1.5rem';
                newP.style.fontWeight = '500';
                newP.style.color = '#000';
                newP.innerText = lastPrice; // your extracted amount
                productPrice.replaceWith(newP);
              } 
            }
      });
    });




    //change the product price summary of spark layer on quantity change

      // const quantityButtons = shadowRoot.querySelectorAll(
      //   '.quantity-selector-wrapper .btn-quantity-selector'
      // );

      // quantityButtons.forEach(btn => {
      //     btn.addEventListener('click', () => {
      //       const productPrice = shadowRoot.querySelector('.price-summary');
      //       const cartAmount = shadowRoot.querySelector('.button-purchase button .purchase-amount').innerText;
      //       const OnlyCartAmount = cartAmount.match(/\((.*?)\)/);
      //       console.log('quantity click', OnlyCartAmount[1]);
      //       if (productPrice) {
      //         const newP = document.createElement('p');
      //         newP.className = 'spark-custom-price';
      //         newP.style.fontSize = '16px';
      //         newP.style.marginBottom = '1.5rem';
      //         newP.style.fontWeight = '500';
      //         newP.style.color = '#000';
      //         newP.innerText = OnlyCartAmount[1]; // your extracted amount
      //         productPrice.replaceWith(newP);
      //         } 
      //   });
      // });
  }, 5000);
});



// Hide the bottom MSRP in the product page on rightside of the product price
// document.addEventListener('DOMContentLoaded',() =>{
//   function removeMsrp(){

//     const observer = new MutationObserver(() => {
//       const shadowHost = document.querySelector('spark-pdp');
//       const shadowRoot = shadowHost.shadowRoot; 
//       const rrpPrice = shadowRoot?.querySelector('.sl-pricing-alignment p:nth-child(2)');
      
//       if (rrpPrice) {
//         rrpPrice.style.display = "none";
//         observer.disconnect(); // once mil jaye, observer band
//       }
//     });
    
//     // poori body observe karo (ya specific parent agar pata ho)
//     observer.observe(document.body, {
//       childList: true,
//       subtree: true
//     });
//   }
//   removeMsrp();
// });
document.addEventListener('DOMContentLoaded', () => {
  const interval = setInterval(() => {
    const shadowHost = document.querySelector('spark-pdp');

    if (!shadowHost || !shadowHost.shadowRoot) return;

    const summary = shadowHost.shadowRoot.querySelector('.sl-pricing-alignment');

    if (summary) {
      summary.style.display = "none";
      clearInterval(interval);
    }
  }, 300);
});


// Esd landing page three grid section text line clamp js 
document.addEventListener('DOMContentLoaded',()=>{

   document.querySelectorAll('.esd-three-sec .esd-three__text').forEach((elm)=>{
      elm.addEventListener('click',()=>{
        elm.classList.toggle('expanded');
      })
   })
});





// Read more and read less on How its done page  "Traditional Methods of Removing Studs" section
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('.methods-section .methods-item .methods-text').forEach(el => {
      const lineHeight = parseFloat(window.getComputedStyle(el).lineHeight);
      const maxHeight = lineHeight * 3;
      if (el.scrollHeight > maxHeight) {
        el.classList.add('clamped');
        el.style.maxHeight = lineHeight * 3 + 10 + 'px';

             const btn = document.createElement('a');
             btn.href = "javascript:void(0)";
             btn.className = 'read-more-btn';
             btn.textContent = '(Read more+)';
             el.parentNode.appendChild(btn);

             // Toggle functionality
              btn.addEventListener('click', function() {
                el.classList.toggle('active');

                if (btn.textContent === '(Read more+)') {
                   el.style.maxHeight = el.scrollHeight + 'px';
                  btn.textContent = '(Read less-)';
                } else {
                  el.style.maxHeight = lineHeight * 3 + 10 + 'px';
                  btn.textContent = '(Read more+)';
                }
              });
      }

  });
  
});


// Read more and read less on How its done page "Issues with stud removal and stud extraction" section
document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('.issues-section .issues-text.methods-text').forEach(el => {
      const lineHeight = parseFloat(window.getComputedStyle(el).lineHeight);
      const maxHeight = lineHeight * 4;
      if (el.scrollHeight > maxHeight) {
        el.classList.add('clamped');
        el.style.maxHeight = lineHeight * 4 + 10 + 'px';

             const btn = document.createElement('a');
             btn.href = "javascript:void(0)";
             btn.className = 'read-more-btn';
             btn.textContent = '(Read more+)';
             el.parentNode.appendChild(btn);

             // Toggle functionality
              btn.addEventListener('click', function() {
                el.classList.toggle('active');

                if (btn.textContent === '(Read more+)') {
                   el.style.maxHeight = el.scrollHeight + 'px';
                  btn.textContent = '(Read less-)';
                } else {
                  el.style.maxHeight = lineHeight * 4 + 10 + 'px';
                  btn.textContent = '(Read more+)';
                }
              });
      }

  });
  
});



